import {type AnchorHTMLAttributes, forwardRef, memo} from 'react';
import {cn} from '../lib/cn';

export interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  disabled?: boolean;
}

const LinkInternal = forwardRef<HTMLAnchorElement, LinkProps>(
  ({disabled = false, className, children, ...props}, ref) => (
    <a
      ref={ref}
      className={cn(
        'inline cursor-pointer text-[var(--link-text-color)] font-[var(--link-font-weight)] [text-decoration:var(--link-text-decoration)] transition-all duration-75 ease-in-out',
        !disabled && 'hover:opacity-80 active:opacity-100',
        disabled && 'cursor-not-allowed text-[var(--link-disabled-text-color)]',
        '[&_img]:inline [&_img]:align-middle [&_svg]:relative [&_svg]:bottom-[1px] [&_svg]:ml-1 [&_svg]:inline [&_svg]:align-middle',
        className,
      )}
      aria-disabled={disabled}
      {...props}
    >
      {children}
    </a>
  ),
);

LinkInternal.displayName = 'Link';

export const Link = memo(LinkInternal);
